<div [formGroup]="formGroup">

  <div class="row no-gutters mb-enter-address-label mb-input-margin-bottom">
    <div class="col-12 field-wrapper text-sm-left"
         mbFloatingLabel
         data-cy="mb-checkout-address-company">
      <label for="companyName"
             class="mandatory-input-asterisk mb-input-field-cursor mb-custom-label">{{ companyLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="companyName"
             name="companyName"
             data-cy="mb-checkout-address-company-input"
             type="text"
             formControlName="companyName"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.COMPANY_CODE)"
                      [prefix]="'addressesValidationErrors'">
      </mb-form-errors>
    </div>
  </div>
  <div [ngClass]="{'container-main no-gutters' : displayShippingLabel}">
    <div class="container-left no-gutters" *ngIf="displayShippingLabel">
      <div class="rectangle-upper no-gutters"></div>
      <div class="shipping-label">
        <span>{{ 'address.notOnShippingLabel' | cxTranslate }}</span>
      </div>
      <div class="rectangle-lower no-gutters"></div>
    </div>
    <div [ngClass]="{'container-right no-gutters' : displayShippingLabel}">
      <div class="row no-gutters mb-input-margin-bottom">
        <div class="col-12 field-wrapper text-sm-left"
            mbFloatingLabel
            data-cy="mb-checkout-address-institute">
          <label for="institute" class="mb-input-field-cursor mb-custom-label">{{ instituteLabelKey | cxTranslate }}</label>
          <input class="w-100 mb-form-input"
                id="institute"
                name="institute"
                data-cy="mb-checkout-address-institute-input"
                type="text"
                formControlName="institute"/>
          <mb-form-errors [control]="formGroup?.get(constants.INSTITUTE_CODE)"
                          [prefix]="'addressesValidationErrors'">
          </mb-form-errors>
        </div>
      </div>
      <div class="row no-gutters mb-input-margin-bottom">
        <div class="col-12 field-wrapper text-sm-left"
            mbFloatingLabel
            data-cy="mb-checkout-address-department">
          <label for="department" class="mb-input-field-cursor mb-custom-label">{{ departmentLabelKey | cxTranslate }}</label>
          <input class="w-100 mb-form-input"
                id="department"
                name="department"
                data-cy="mb-checkout-address-department-input"
                type="text"
                formControlName="department"/>
          <mb-form-errors [control]="formGroup?.get(constants.DEPARTMENT_CODE)"
                          [prefix]="'addressesValidationErrors'">
          </mb-form-errors>
        </div>
      </div>
      <div class="row no-gutters mb-input-margin-bottom">
        <div class="col-12 field-wrapper text-sm-left"
            mbFloatingLabel
            data-cy="mb-checkout-address-lab">
          <label for="lab" class="mb-input-field-cursor mb-custom-label">{{ labLabelKey | cxTranslate }}</label>
          <input class="w-100 mb-form-input"
                id="lab"
                name="lab"
                data-cy="mb-checkout-address-lab-input"
                type="text"
                formControlName="lab"/>
          <mb-form-errors [control]="formGroup?.get(constants.LAB_CODE)"
                          [prefix]="'addressesValidationErrors'">
          </mb-form-errors>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper text-sm-left"
         mbFloatingLabel
         data-cy="mb-checkout-address-building">
      <label for="building" class="mb-input-field-cursor mb-custom-label">{{ buildingLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="building"
             name="building"
             data-cy="mb-checkout-address-building-input"
             type="text"
             formControlName="building"/>
      <mb-form-errors [control]="formGroup?.get(constants.BUILDING_CODE)"
                      [prefix]="'addressesValidationErrors'">
      </mb-form-errors>
    </div>
  </div>
</div>

